import { AvailableComponents } from "../../Components";

import './styles.css'

export default function Row({ config }) {
    return (
        <div
            className="row"
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                ...(config.style || {})
            }}
            id={config.config?.id}
        >
            {config.content.map((content, i) => {
                const Component = AvailableComponents[content.type];
                if (!Component) return null;
                return (
                    <Component key={"component-" + i} config={content.settings} />
                );
            })}
        </div>
    );
}
